// extracted by mini-css-extract-plugin
module.exports = {"category":"categories-loader_category__ubHO2","shine":"categories-loader_shine__Hvhih"};